// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"m_-z"};